<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="25" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">工作状态</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="16px" x="1" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Working position</textPath>
                            </text>
                        </g>
                        <!-- <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">油 缸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="31" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Assemble</textPath>
                            </text>
                        </g> -->
                        <!-- <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">型号</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                            椭圆  A(rx, ry, xr, laf, sf, x, y)
                            rx: 椭圆X轴半径
                            ry: 椭圆Y轴半径
                            xr: 椭圆旋转角度
                            laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                            sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                            x: 终点X轴坐标
                            y: 终点Y轴坐标
                        </g> -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
                    <div
                      v-for="(item,index) in upperObj"
                      :key="index"
                      :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                      @click="upperAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <!-- <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                    <div
                      v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div> -->
        </div>

        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>
        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    export default {
        components: {
            Loader,
            Nav,
            language,
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                upperActive:null, //当前选项下标
                is_hidenote:true,

                downActive:1, //当前选项下标

                localPlaneLV1: new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7),
                localPlaneLAN1: new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7),
                modelanimationList:null,
                tweenplane:null,
                filterstatus:1, //0默认

                lang: 'cn', // 语言
                upperObj:[ //上模选项
                {
                    id: 1,
                    text: '正常工作', //菜单显示
                    en_text: 'Normal working position', //菜单显示(英文)
                    warn: '',
                    en_warn: '',
                    animate_number: '1',
                  },
                  {
                    id: 0,
                    text: '切换方向', //菜单显示
                    en_text: 'Switch direction', //菜单显示(英文)
                    warn: '<p>1.控制油缸上移改变料流的方向，用于切换料流方向或快速排除螺杆中的废料</p>',
                    en_warn: '<p>Control the upward movement of the oil cylinder to change the direction of material flow, for switching the direction of material flow or eliminating the waste from the screw. </p>',
                    animate_number: '1',
                  },

                ],
                // downObj: [ //下模选项
                //   {
                //     id: 0,
                //     text: '方向1', //菜单显示
                //     en_text: 'Step 1', //菜单显示(英文)
                //     warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                //     en_warn: '<p>1、逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                //     animate_number: '1',
                //   },
                //   {
                //     id: 1,
                //     text: '方向2', //菜单显示
                //     en_text: 'Step 1', //菜单显示(英文)
                //     warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                //     en_warn: '<p>1、逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                //     animate_number: '1',
                //   },
                // ],
            }
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true,
                  // 设置对数深度缓冲区，优化深度冲突问题
                  logarithmicDepthBuffer: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.sortObjects = false; //(物体的渲染顺序将会由他们添加到场景中的顺序所决定) 关闭自定义顺序，也就是按照默认排序。 决定是材质先后起作用还是添加到场景的先后起作用
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 80);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
              // _this.controls.target.set(0,10,0)
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/kcf/kcf-me.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations
                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.animate();
                _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
                _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })

              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if ( this.toobarActive == e ) {
              this.attentionStatus = false
              this.toobarActive = '';
              _this.localPlaneLV1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
              _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
              _this.localPlaneLAN1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
              _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
                _this.clipAction = null
              }
              if(_this.tweenplane){
                _this.tweenplane.stop()
              }
              this.showallcomponents()
              this.filterstatus = 1
              this.upperActive = null
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 80,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }else{
              this.toobarActive = e;
            }
          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function(item) {
            let _this = this;
            this.attentionStatus = true
            this.upperActive = item.id
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            _this.transparentComponents(["yc","zx","nb","zb","hb"],0.3)
            if(_this.tweenplane){
              _this.tweenplane.stop()
            }
            _this.localPlaneLV1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
            _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
            _this.localPlaneLAN1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
            _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
            // console.log("id",item.id);
            // console.log("_this.filterstatus",_this.filterstatus);
            switch (item.id) {
              case 0:
                newP = { //新的相机位置
                  x: 0,
                  y: 0,
                  z: 30,
                }
                if(_this.filterstatus == 0){
                  _this.flowDirection('lv')
                }else{
                  _this.filterstatus = -1 //转换中
                  let nowTime = 0
                  if(_this.clipAction){ //如果有动画则先停止播放
                    // console.log('有动画');
                    // console.log("已播放时间",_this.clipAction.time);
                    nowTime = 2.5 - _this.clipAction.time
                    if(_this.clipAction._clip.name == '1'){
                      nowTime = _this.clipAction.time
                    }
                    // console.log("从",nowTime,"秒开始播放");
                    _this.clipAction.stop()
                    _this.clipAction = null
                  }
                  //包含关键帧动画的模型作为参数创建一个播放器
                  _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
                  //  获取gltf.animations[0]的第一个clip动画对象
                  _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[0]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)  绿色流向位置
                  _this.clipAction.time = nowTime
                  _this.clipAction.play(); //播放动画
                  _this.clipAction.loop = THREE.LoopOnce; //不循环播放
                  _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
                  _this.mixer.addEventListener('finished', function( e ) { //全部动作的结束时调用
                    // console.log('已结束');
                    _this.filterstatus = 0 //绿
                    _this.flowDirection('lv')
                  });
                }
                break;
              case 1: //2
                newP = { //新的相机位置
                  x: 20,
                  y: 10,
                  z: 20,
                }
                if(_this.filterstatus == 1){
                  _this.flowDirection('lan')
                }else{
                  _this.filterstatus = -1 //转换中
                  let nowTime = 0
                  if(_this.clipAction){ //如果有动画则先停止播放
                    // console.log("已播放时间",_this.clipAction.time);
                    nowTime = 2.5 - _this.clipAction.time
                    if(_this.clipAction._clip.name == '2'){
                      nowTime = _this.clipAction.time
                    }
                    _this.clipAction.stop()
                    // console.log("从",nowTime,"秒开始播放");
                    _this.clipAction = null
                  }
                  //包含关键帧动画的模型作为参数创建一个播放器
                  _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
                  //  获取gltf.animations[0]的第一个clip动画对象
                  _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据) 蓝色流向位置
                  _this.clipAction.time = nowTime
                  _this.clipAction.play(); //播放动画
                  _this.clipAction.loop = THREE.LoopOnce; //不循环播放
                  _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
                  _this.mixer.addEventListener('finished', function( e ) { //全部动作的结束时调用
                    // console.log('已结束');
                    _this.filterstatus = 1 //蓝
                    _this.flowDirection('lan')
                  });
                }
                break;
              default:
                break;
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP
            _this.tweenCamera(oldP, oldT, newP, newT);
          },
          //
          flowDirection(name){
            let _this = this;

            switch (name) {
              case 'lv':
                _this.tweenplane = new TWEEN.Tween(_this.localPlaneLV1).to({constant: -3}, 600);
                _this.tweenplane.onUpdate(function (object) { //第一阶段
                  _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
                }).onComplete(function() {
                  _this.tweenplane = new TWEEN.Tween(_this.localPlaneLV1).to({normal:{x:0,y:1,z:0},constant:2}, 500);
                  _this.tweenplane.onUpdate(function (object) { //第二阶段
                    _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
                  }).onComplete(function(){
                    _this.tweenplane = new TWEEN.Tween(_this.localPlaneLV1).to({constant: 9}, 1200);
                    _this.tweenplane.onUpdate(function (object) {//第三阶段
                      _this.model.getObjectByName("lv").children[0].material.clippingPlanes = [_this.localPlaneLV1];
                    }).onComplete(function(){
                      _this.tweenplane.length = 0
                    })
                    _this.tweenplane.start();
                  })
                  _this.tweenplane.start();
                })
                _this.tweenplane.start();
                break;
              case 'lan':
                _this.tweenplane = new TWEEN.Tween(_this.localPlaneLAN1).to({constant: -3}, 600);
                _this.tweenplane.onUpdate(function (object) { //第一阶段
                  _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
                }).onComplete(function() {
                  _this.tweenplane = new TWEEN.Tween(_this.localPlaneLAN1).to({normal:{x:0,y:0,z:-1},constant:2}, 500);
                  _this.tweenplane.onUpdate(function (object) { //第二阶段
                    _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
                  }).onComplete(function(){
                    _this.tweenplane = new TWEEN.Tween(_this.localPlaneLAN1).to({constant: 9}, 1000);
                    _this.tweenplane.onUpdate(function (object) {//第三阶段
                      _this.model.getObjectByName("lan").children[0].material.clippingPlanes = [_this.localPlaneLAN1];
                    }).onComplete(function(){
                      _this.tweenplane.length = 0
                    })
                    _this.tweenplane.start();
                  })
                  _this.tweenplane.start();
                })
                _this.tweenplane.start();
                break;
              default:
                break;
            }
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          // downAnimate: function(item) {
          //   let _this = this;
          //   this.downActive = item.id
          //   this.upperActive = null
          //   // this.transparentComponents(["zx","yc"],true)
          //   _this.model.getObjectByName("zx").material.opacity = 1
          //   _this.model.getObjectByName("yc").material.opacity = 1
          //   if (_this.lang == 'cn') {
          //     if(item.warn){
          //       _this.attentionText = item.warn;
          //     }else{
          //       _this.attentionText = null
          //     }
          //   } else {
          //     if(item.en_warn){
          //       _this.attentionText = item.en_warn;
          //     }else{
          //       _this.attentionText = null
          //     }
          //   }

          //   _this.localPlaneLV1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
          //   _this.model.getObjectByName("lv").material.clippingPlanes = [_this.localPlaneLV1];
          //   _this.localPlaneLAN1 = new THREE.Plane(new THREE.Vector3(1, 0, 0), -7.7)
          //   _this.model.getObjectByName("lan").material.clippingPlanes = [_this.localPlaneLAN1];
          //   if(_this.tweenplane){
          //     _this.tweenplane.stop()
          //   }
          //   if(this.filterstatus == item.id){

          //   }else{

          //     let nowTime = 0
          //     if(_this.clipAction){ //如果有动画则先停止播放
          //       nowTime = _this.clipAction.time
          //       _this.clipAction.stop()
          //     }
          //     _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
          //     _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[0]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
          //     _this.clipAction.time = nowTime
          //     if(item.id == 0){
          //       _this.clipAction.loop = THREE.LoopOnce; //不循环播放
          //       _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
          //       _this.clipAction.play(); //播放动画
          //     }else if(item.id == 1){
          //       _this.clipAction.timeScale = -1; // 设置时间缩放为负值即可倒放动画
          //       setTimeout(() => {
          //         _this.clipAction.loop = THREE.LoopOnce; //不循环播放
          //         _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
          //       }, 500);
          //       _this.clipAction.play(); //播放动画
          //     }
          //     _this.filterstatus = item.id
          //   }
          // },

          /**
           * @description 显示透明组件
           * @param {array} e 透明名列表
           * @param {Boolean} e （0透明）or（1显示）
           */
          transparentComponents(objectArray,opcity,determine = false){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              // console.log(objectArray);
              // console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]).children[0] instanceof THREE.Mesh) {
                  // _this.model.getObjectByName(objectArray[i]).material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                  // _this.model.getObjectByName(objectArray[i]).material.color.set("#222")
                  _this.model.getObjectByName(objectArray[i]).children[0].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                  _this.model.getObjectByName(objectArray[i]).children[0].material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).children[0].material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]).children[0] instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children[0].children.length; j++) {
                  // _this.model.getObjectByName(objectArray[i]).children[j].material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                  // _this.model.getObjectByName(objectArray[i]).children[j].material.color.set("#222")
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          // 问题：
          // 绘制的一个半透明的平面，在某个角度观察时，发现后面的模型被遮挡了
          // 解决办法：
          // 1.设置material的depthWrite属性为false
          // 2.设置material的depthTest属性为false
          // depthWrite：渲染此材质是否对深度缓冲区有任何影响。默认为true
          // depthTest：是否在渲染此材质时启用深度测试。默认为 true。  (不进行深度测试，直接通过，混合颜色)

          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.depthWrite = true
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                // console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this

            // _this.transparentComponents(["yc","nb","zx"],0.4)
            // _this.transparentComponents(["zx","jb","yc","zb","hb"],0.2) //外层
            // _this.ShowHideComponents(["zx"],false)
            // _this.transparentComponents(["zx"],0.2)
            // console.log(_this.model.getObjectByName("lv"),"lv");
            console.log(_this.model.getObjectByName("yc"),"yc");
            console.log(_this.model.getObjectByName("zx"),"zx");
            console.log(_this.model.getObjectByName("nb"),"nb");
            console.log(_this.model.getObjectByName("zb"),"zb");
            console.log(_this.model.getObjectByName("hb"),"hb");
            // console.log(_this.model.getObjectByName("lan"),"lan");
            // console.log(_this.model.getObjectByName("lv"),"lv");
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }
            // for (let i = 1; i < 4; i++) {
            //   console.log(_this.model.getObjectByName("HX"+i),"HX"+i);
            // }
          },
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          // this.raycasterclick()
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/kcf.vue